import '@styles/code-demo-toolbar.styl';
import template from './code-demo-toolbar.html';

export default {
  name: 'code-demo-toolbar',
  template
};
